import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "../styles/faqs.css"; // make sure you create this file

const faqsData = [
  {
    question: "How can I purchase a vehicle from Matel Trading?",
    answer:
      "You can purchase a vehicle by visiting our showroom or browsing our inventory online. Once you’ve selected a vehicle, our sales team will guide you through payment, documentation, and delivery.",
  },
  {
    question: "Do you offer vehicle financing?",
    answer:
      "Yes, we partner with reputable financial institutions to help our customers secure flexible financing options. Please contact our sales team for guidance on financing applications.",
  },
  {
    question: "Can I trade in my old car?",
    answer:
      "Absolutely! We offer trade-in options after a quick vehicle evaluation. You can apply your car’s value toward a new purchase.",
  },
  {
    question: "Do the vehicles come with a warranty?",
    answer:
      "Yes. Depending on the make, model, and condition, our vehicles may come with a limited warranty. Our sales consultants will clarify warranty details for each car.",
  },
  {
    question: "How do I contact Matel Trading?",
    answer:
      "You can reach us via email at info@mateltrading.com or call us at +254 700 123 456. Visit our showroom for in-person assistance.",
  },
];

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="theme--2">
      <div className="faq-container">
        <header className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about our services and vehicles.</p>
        </header>

        <div className="faq-list">
          {faqsData.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? "active" : ""}`}>
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                <span>{faq.question}</span>
                {openIndex === index ? (
                  <FaChevronUp className="faq-icon" />
                ) : (
                  <FaChevronDown className="faq-icon" />
                )}
              </button>
              {openIndex === index && <p className="faq-answer">{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQs;
